<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Software Projects'
            :titleIcon='softwareDivision.icon'
            :titleIconColor='softwareDivision.icon_color'
            :loading='isLoading'
          >
            <template v-slot:toolbarButtons>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              dense
              :headers='headers'
              :items='projects'
              :search='search'
              :items-per-page='25'
              sort-by='name'
              no-data-text='No Software Projects Found'
              @click:row='openProject'
            >
              <template v-slot:item.start_date='{ item }'>
                {{ item.start_date | shortDate }}
              </template>
              <template v-slot:item.end_date='{ item }'>
                {{ item.end_date | shortDate }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import projectsAPI from '@/modules/projects/api/projects'

export default {
  name: 'lawn-dashboard',
  data: () => ({
    isLoading: true,
    projects: [],
    search: '',
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Number', value: 'number' },
      { text: 'Address', value: 'site_address' },
      { text: 'City', value: 'site_city' },
      { text: 'Start Date', value: 'start_date', align: 'center' },
      { text: 'End Date', value: 'end_date', align: 'center' }
    ]
  }),
  mounted () {
    this.getProjects()
  },
  computed: {
    softwareDivision () {
      return this.$store.state.misc.divisions.find(d => d.division === 'Software')
    }
  },
  methods: {
    async getProjects () {
      this.isLoading = true
      let projects = await projectsAPI.getDivisionProjects(this.softwareDivision)
      this.projects = _.filter(projects, p => !p.archived)
      this.isLoading = false
    },
    openProject (item) {
      this.$router.push({ name: 'SoftwareOverview', params: { id: item.id } })
    }
  }
}
</script>